import { useEffect } from 'react';

type UseOverrideFullscreenModalStylesProps = {
  visible: boolean;
  hideCloseButton?: boolean;
};

export function useOverrideFullscreenModalStyles({
  visible,
  hideCloseButton = false,
}: UseOverrideFullscreenModalStylesProps) {
  // override fullscreenmodal background
  useEffect(() => {
    const modalsContainer = document.getElementById('modalsContainer');
    if (modalsContainer?.children.length === 1) {
      modalsContainer.style.setProperty('--background', 'transparent');
      const questionOverlay = document.querySelector(
        '[data-testid="custom-fullscreen-modal"] [class*="cds-backgroundOverlay"]',
      ) as HTMLElement;
      if (questionOverlay) {
        questionOverlay.style.backgroundColor = 'rgba(10,11,13,0.9)';
        questionOverlay.style.backdropFilter = 'blur(30px)';
        questionOverlay.style.transition = 'all 0.6s cubic-bezier(0.60, 0.00, 0.15, 1.00)';
      }
      const questionModalBackground = document.querySelector(
        '[data-testid="custom-fullscreen-modal"] [class*="cds-background"][class*="cds-containerClassName"]',
      ) as HTMLElement;
      if (questionModalBackground) {
        questionModalBackground.style.backgroundColor = 'transparent';
      }
      const defaultCloseButton = document.querySelector(
        '[data-testid="custom-fullscreen-modal"] [aria-label="Close"]',
      ) as HTMLElement;
      if (defaultCloseButton && hideCloseButton) {
        defaultCloseButton.style.display = 'none';
      }
    }
  }, [visible, hideCloseButton]);
}
